// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type InfoCircle14FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const InfoCircle14Filled: FC<InfoCircle14FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="14"
            height="14"
        >
            <path d="M6.475 9.8h1.05V6.3h-1.05v3.5Zm.522-4.55a.515.515 0 0 0 .528-.522.515.515 0 0 0-.522-.528.515.515 0 0 0-.528.522.515.515 0 0 0 .522.528Zm.007 7.35c-.77 0-1.496-.146-2.177-.438a5.644 5.644 0 0 1-1.786-1.203 5.646 5.646 0 0 1-1.204-1.785 5.473 5.473 0 0 1-.437-2.18c0-.774.146-1.498.437-2.174a5.646 5.646 0 0 1 2.989-2.982 5.473 5.473 0 0 1 2.18-.438c.774 0 1.499.146 2.174.438a5.667 5.667 0 0 1 2.982 2.985c.292.678.438 1.402.438 2.173 0 .77-.146 1.496-.438 2.177a5.645 5.645 0 0 1-2.985 2.99 5.439 5.439 0 0 1-2.173.437Z" />
        </svg>
    );
};

export default InfoCircle14Filled;
